import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useChromeVariant } from './useChromeVariant';

/**
 * The tab title: `<area> | <application>` — "Gruppen-Policen | EMIL Insurance Suite" in
 * the suite variant (Board 2 of the hand-off sketches: the two tabs must be tellable apart by
 * name), "Gruppen-Policen | EIS Console" in Berry. Without an area (the start page) the
 * application name stands alone.
 */
export function useDocumentTitle(area: string | undefined): void {
  const { t } = useTranslation('shell');
  const suite = useChromeVariant().variant === 'suite';
  useEffect(() => {
    const app = t(suite ? 'app.suiteName' : 'app.name');
    document.title = area === undefined ? app : t('app.windowTitle', { area, app });
  }, [area, suite, t]);
}
